var map = {
	"./1.png": "6615",
	"./2.png": "88fc",
	"./3.png": "6a01",
	"./4.png": "57f5",
	"./5.png": "48c6",
	"./6.png": "028a",
	"./7.png": "9745",
	"./8.png": "76be"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "80b0";